import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import ImagesUploader from 'components/ImagesUploader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';

class ImagesFieldset extends Component {
  static propTypes = {
    submissionForm: ImmutablePropTypes.map.isRequired,
    uploadImage: PropTypes.func.isRequired,
    removeImage: PropTypes.func.isRequired,
    imageErrorVisible: PropTypes.bool.isRequired,
    publisherLogosEnabled: PropTypes.bool
  };

  render() {
    const images = this.props.submissionForm.getIn(['data', 'images']);
    const backendError = this.props.submissionForm.getIn(['data', 'imagesLastError']);

    return (
      <ImagesUploader
        images={images}
        isUploading={this.props.submissionForm.get('isUploading')}
        onUpload={this.props.uploadImage}
        onRemove={this.props.removeImage}
        errorVisible={this.props.imageErrorVisible}
        backendError={backendError}
        maxImages={5}
        publisherLogosEnabled={this.props.publisherLogosEnabled}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    submissionForm: state.submissionForm,
    publisherLogosEnabled: state.config.getIn(['origin_publisher_data', 'promoter_logos'])
  });
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImagesFieldset);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/ImagesFieldset.jsx